export default "__VITE_ASSET__DN6PNmx1__"